/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tea_Package_WeightInputs */

const vi_tea_package_weight = /** @type {(inputs: Tea_Package_WeightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Khối lượng (kg)`)
};

/**

* @param {Tea_Package_WeightInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const tea_package_weight = /** @type {((inputs?: Tea_Package_WeightInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tea_Package_WeightInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_tea_package_weight(inputs)
});